import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="Amek a turared" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Afed awal g 6 iverdan. M kul avrid, tiɣmi (couleure) n wamḍiq atvedel
        aken a divin ma t'qerveḍ ar w awal ni.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="A"
          status="correct"
        />
        <Cell value="V" />
        <Cell value="R" />
        <Cell value="I" />
        <Cell value="D" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Asekkil A yela g awal g wamḍiq is.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="S" />
        <Cell value="E" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="K"
          status="present"
        />
        <Cell value="S" />
        <Cell value="U" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Asekkil K yela g awal acu mači g wamḍiq is.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="T" />
        <Cell value="I" />
        <Cell value="Ɣ" />
        <Cell isRevealing={true} isCompleted={true} value="R" status="absent" />
        <Cell value="I" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Asekkil R ulac it g awal.
      </p>

      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
        This game is created by Ghiles G. in the Kabyle language and is inspired by the word guessing game
		we all know and enjoy playing. It exists in several other languages. Contact: awalwordgame@gmail.com https://awal.isoliton.com{' '}
        <a
          href="https://awal.isoliton.com"
          className="underline font-bold"
        >
          
        </a>{' '}
      </p>
    </BaseModal>
  )
}
